var _g, _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBcycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1080 1080",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.09637,-1.34266e-16,1.3348e-16,-1.08994,1251.86,1177.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.287,89.123C649.287,89.123 332.311,559.546 332.311,761.156C332.311,937.131 474.343,1080 649.287,1080C824.231,1080 966.263,937.131 966.263,761.156C966.263,559.546 649.287,89.123 649.287,89.123Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.889518,0,0,0.889518,-77.171,-53.592)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 693.826,
    cy: 432.999,
    r: 334.437,
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "1.12px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.814184,0,0,0.814184,540,331.569)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-320,-256)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 640,
    height: 512
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.509,192.001C496.136,191.937 480.479,194.956 466.073,200.496L388.393,75.343C384.02,68.297 376.294,64 368.001,64L304.001,64C295.164,64 288.001,71.163 288.001,80L288.001,96C288.001,104.837 295.164,112 304.001,112L354.65,112L369.546,136L256.002,136L256.002,120C256.002,111.163 248.839,104 240.002,104L152.543,104C139.102,104 127.766,114.999 128.007,128.437C128.239,141.481 138.883,152 152.002,152L200.728,152L171.311,199.52C157.878,194.69 143.407,192.037 128.319,192C58.094,191.83 0.412,249.012 0.002,319.236C-0.413,390.279 57.055,448 128.002,448C187.644,448 237.76,407.207 251.969,352L304.002,352C312.304,352 320.038,347.692 324.408,340.633L410.37,201.77L425.308,225.837C399.853,249.285 383.923,282.918 384.001,320.274C384.146,389.107 441.9,447.325 510.73,447.993C581.336,448.678 638.911,392.19 639.985,321.997C641.071,251.056 583.459,192.277 512.509,192.001ZM186.75,265.772C196.477,276.301 203.423,289.433 206.392,304L163.086,304L186.75,265.772ZM128.002,400C83.89,400 48.002,364.112 48.002,320C48.002,275.888 83.89,240 128.002,240C133.871,240 139.588,240.653 145.101,241.859L99.596,315.368C89.715,331.327 101.213,352 120.002,352L201.302,352C188.932,380.225 160.74,400 128.002,400ZM290.632,304L255.008,304C251.048,272.244 235.452,244.106 212.625,223.974L237.371,184L364.918,184L290.632,304ZM507.689,399.886C466.653,397.721 433.64,364.194 432.062,323.131C431.25,302.01 438.695,282.613 451.397,267.868L495.83,339.454C500.49,346.962 510.354,349.27 517.862,344.61L531.456,336.173C538.964,331.513 541.273,321.649 536.612,314.141L492.144,242.498C498.632,240.837 505.304,239.998 512.002,240.001C556.114,240.001 592.002,275.889 592.002,320.001C592.001,365.541 553.75,402.317 507.689,399.886Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcycle);
export default __webpack_public_path__ + "static/media/bcycle.a360ae930b2afd584008292fcbc0393b.svg";
export { ForwardRef as ReactComponent };